// Fully anonymized mock RCA dashboard response
const MOCK_RCA_RESPONSE = {
  "filters": null,
  "row_header": null,
  "row_data": [
    {
      "_id": "d51b0353e2126538ca28d429",
      "achievement_pct": "0%",
      "action_plan": "Coordinate with logistics for next slot",
      "activation_date": "",
      "actual": 0.0,
      "comments": [],
      "dealer_code": "D100000",
      "dealer_name": "Partner Account 1",
      "district": "District E-A",
      "district_code": "DE01",
      "email_date": "2026-07-09",
      "email_type": "account_owner",
      "escalation": "E2",
      "forecast_shortfall": 0,
      "id_issue": "ISS-2000",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 20.0,
      "plant_description": "Plant Alpha",
      "region": "Area E1",
      "responsible_email_id": "owner0@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner A",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Supply delay impacting monthly target",
      "state": "Zone East",
      "state_head": "Lead A",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater0@example.com",
      "updated_by_name": "Updater A",
      "view_state": "Zone East"
    },
    {
      "_id": "ab3041649fb96de5a4d33d11",
      "achievement_pct": "7%",
      "action_plan": "Resume dispatch after clearance",
      "activation_date": "2026-07-21",
      "actual": 3.5,
      "comments": [],
      "dealer_code": "D100001",
      "dealer_name": "Partner Account 2",
      "district": "District E-A",
      "district_code": "DE01",
      "email_date": "2026-07-10",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 5,
      "id_issue": "ISS-2001",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 31.3,
      "plant_description": "Plant Alpha",
      "region": "Area E1",
      "responsible_email_id": "owner1@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner B",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Dispatch hold at origin",
      "state": "Zone East",
      "state_head": "Lead B",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater1@example.com",
      "updated_by_name": "Updater B",
      "view_state": ""
    },
    {
      "_id": "f2a27ac52f6b5b6d27dded9d",
      "achievement_pct": "14%",
      "action_plan": "Share alternate supply plan",
      "activation_date": "2026-07-21",
      "actual": 7.0,
      "comments": [],
      "dealer_code": "D100002",
      "dealer_name": "Partner Account 3",
      "district": "District E-A",
      "district_code": "DE01",
      "email_date": "2026-07-11",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 10,
      "id_issue": "ISS-2002",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 42.6,
      "plant_description": "Plant Alpha",
      "region": "Area E1",
      "responsible_email_id": "owner2@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner C",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Material availability shortfall",
      "state": "Zone East",
      "state_head": "Lead C",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater2@example.com",
      "updated_by_name": "Updater C",
      "view_state": ""
    },
    {
      "_id": "902d2e3b4b23ac86f91fd76c",
      "achievement_pct": "21%",
      "action_plan": "Club with nearby partner orders",
      "activation_date": "",
      "actual": 10.5,
      "comments": [],
      "dealer_code": "D100003",
      "dealer_name": "Partner Account 4",
      "district": "District E-A",
      "district_code": "DE01",
      "email_date": "2026-07-12",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 15,
      "id_issue": "ISS-2003",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 53.9,
      "plant_description": "Plant Alpha",
      "region": "Area E1",
      "responsible_email_id": "owner3@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner D",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Short delivery request pending",
      "state": "Zone East",
      "state_head": "Lead D",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater3@example.com",
      "updated_by_name": "Updater D",
      "view_state": "Zone East"
    },
    {
      "_id": "2467ce78d8b0b4958b2106f7",
      "achievement_pct": "28%",
      "action_plan": "Follow up with plant operations",
      "activation_date": "2026-07-21",
      "actual": 14.0,
      "comments": [],
      "dealer_code": "D100004",
      "dealer_name": "Partner Account 5",
      "district": "District E-A",
      "district_code": "DE01",
      "email_date": "2026-07-13",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 20,
      "id_issue": "ISS-2004",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 65.2,
      "plant_description": "Plant Alpha",
      "region": "Area E1",
      "responsible_email_id": "owner4@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner E",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Depot stock outage",
      "state": "Zone East",
      "state_head": "Lead E",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater4@example.com",
      "updated_by_name": "Updater E",
      "view_state": ""
    },
    {
      "_id": "7066589ef68fa0ad5f3e126c",
      "achievement_pct": "35%",
      "action_plan": "Confirm depot replenishment",
      "activation_date": "2026-07-21",
      "actual": 17.5,
      "comments": [],
      "dealer_code": "D100005",
      "dealer_name": "Partner Account 6",
      "district": "District N-A",
      "district_code": "DN01",
      "email_date": "2026-07-14",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 25,
      "id_issue": "ISS-2005",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 76.5,
      "plant_description": "Plant Alpha",
      "region": "Area N1",
      "responsible_email_id": "owner5@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner F",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Transport not available for split drop",
      "state": "Zone North",
      "state_head": "Lead F",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater5@example.com",
      "updated_by_name": "Updater F",
      "view_state": ""
    },
    {
      "_id": "c38ace4339c1cad9a4cfe381",
      "achievement_pct": "42%",
      "action_plan": "Coordinate with logistics for next slot",
      "activation_date": "",
      "actual": 21.0,
      "comments": [],
      "dealer_code": "D100006",
      "dealer_name": "Partner Account 7",
      "district": "District N-A",
      "district_code": "DN01",
      "email_date": "2026-07-15",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 30,
      "id_issue": "ISS-2006",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 87.8,
      "plant_description": "Plant Alpha",
      "region": "Area N1",
      "responsible_email_id": "owner6@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner G",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Lead time higher than commitment",
      "state": "Zone North",
      "state_head": "Lead A",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater0@example.com",
      "updated_by_name": "Updater A",
      "view_state": "Zone North"
    },
    {
      "_id": "716e80c63130108677c95c81",
      "achievement_pct": "49%",
      "action_plan": "Resume dispatch after clearance",
      "activation_date": "2026-07-21",
      "actual": 24.5,
      "comments": [],
      "dealer_code": "D100007",
      "dealer_name": "Partner Account 8",
      "district": "District N-A",
      "district_code": "DN01",
      "email_date": "2026-07-16",
      "email_type": "account_owner",
      "escalation": "E2",
      "forecast_shortfall": 35,
      "id_issue": "ISS-2007",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 99.1,
      "plant_description": "Plant Alpha",
      "region": "Area N1",
      "responsible_email_id": "owner7@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner H",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Order stuck pending plant confirmation",
      "state": "Zone North",
      "state_head": "Lead B",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater1@example.com",
      "updated_by_name": "Updater B",
      "view_state": ""
    },
    {
      "_id": "b12869d613340974ebcaf2b1",
      "achievement_pct": "56%",
      "action_plan": "Share alternate supply plan",
      "activation_date": "2026-07-21",
      "actual": 28.0,
      "comments": [],
      "dealer_code": "D100008",
      "dealer_name": "Partner Account 9",
      "district": "District N-B",
      "district_code": "DN02",
      "email_date": "2026-07-17",
      "email_type": "account_owner",
      "escalation": "E2",
      "forecast_shortfall": 40,
      "id_issue": "ISS-2008",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 110.4,
      "plant_description": "Plant Alpha",
      "region": "Area N2",
      "responsible_email_id": "owner0@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner A",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Supply delay impacting monthly target",
      "state": "Zone North",
      "state_head": "Lead C",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater2@example.com",
      "updated_by_name": "Updater C",
      "view_state": ""
    },
    {
      "_id": "08435feb8a86805d3bf64ef3",
      "achievement_pct": "63%",
      "action_plan": "Club with nearby partner orders",
      "activation_date": "",
      "actual": 31.5,
      "comments": [
        {
          "_id": "cmt91",
          "attachments": [],
          "author": {
            "email": "user4@example.com",
            "type": "RESPONSIBLE"
          },
          "comment": "Status update 10",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2009",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100009",
      "dealer_name": "Partner Account 10",
      "district": "District N-B",
      "district_code": "DN02",
      "email_date": "2026-07-18",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 45,
      "id_issue": "ISS-2009",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "user4@example.com",
      "month": "Jul-26",
      "mtd_target": 121.7,
      "plant_description": "Plant Alpha",
      "region": "Area N2",
      "responsible_email_id": "owner1@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner B",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Dispatch hold at origin",
      "state": "Zone North",
      "state_head": "Lead D",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater3@example.com",
      "updated_by_name": "Updater D",
      "view_state": "Zone North"
    },
    {
      "_id": "22eadf1fce9c68b964474dc7",
      "achievement_pct": "70%",
      "action_plan": "Follow up with plant operations",
      "activation_date": "2026-07-21",
      "actual": 35.0,
      "comments": [
        {
          "_id": "cmt101",
          "attachments": [],
          "author": {
            "email": "user0@example.com",
            "type": "OWNER"
          },
          "comment": "Status update 11",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2010",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100010",
      "dealer_name": "Partner Account 11",
      "district": "District N-B",
      "district_code": "DN02",
      "email_date": "2026-07-19",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 50,
      "id_issue": "ISS-2010",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "user0@example.com",
      "month": "Jul-26",
      "mtd_target": 133.0,
      "plant_description": "Plant Alpha",
      "region": "Area N2",
      "responsible_email_id": "owner2@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner C",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Material availability shortfall",
      "state": "Zone North",
      "state_head": "Lead E",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater4@example.com",
      "updated_by_name": "Updater E",
      "view_state": ""
    },
    {
      "_id": "f65e3e86dd0d478e0d73a930",
      "achievement_pct": "77%",
      "action_plan": "Confirm depot replenishment",
      "activation_date": "2026-07-21",
      "actual": 38.5,
      "comments": [
        {
          "_id": "cmt111",
          "attachments": [],
          "author": {
            "email": "user1@example.com",
            "type": "RESPONSIBLE"
          },
          "comment": "Status update 12",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2011",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100011",
      "dealer_name": "Partner Account 12",
      "district": "District N-B",
      "district_code": "DN02",
      "email_date": "2026-07-20",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 55,
      "id_issue": "ISS-2011",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "user1@example.com",
      "month": "Jul-26",
      "mtd_target": 144.3,
      "plant_description": "Plant Alpha",
      "region": "Area N2",
      "responsible_email_id": "owner3@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner D",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Short delivery request pending",
      "state": "Zone North",
      "state_head": "Lead F",
      "status": "CLOSED",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater5@example.com",
      "updated_by_name": "Updater F",
      "view_state": ""
    },
    {
      "_id": "4f4d12fa4c878d1a56488f19",
      "achievement_pct": "84%",
      "action_plan": "Coordinate with logistics for next slot",
      "activation_date": "",
      "actual": 42.0,
      "comments": [
        {
          "_id": "cmt121",
          "attachments": [],
          "author": {
            "email": "user2@example.com",
            "type": "OWNER"
          },
          "comment": "Status update 13",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2012",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100012",
      "dealer_name": "Partner Account 13",
      "district": "District W-A",
      "district_code": "DW01",
      "email_date": "2026-07-21",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 60,
      "id_issue": "ISS-2012",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "user2@example.com",
      "month": "Jul-26",
      "mtd_target": 155.6,
      "plant_description": "Plant Beta",
      "region": "Area W1",
      "responsible_email_id": "owner4@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner E",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Depot stock outage",
      "state": "Zone West",
      "state_head": "Lead A",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater0@example.com",
      "updated_by_name": "Updater A",
      "view_state": "Zone West"
    },
    {
      "_id": "0c1a4a4c5ba368c9388f3097",
      "achievement_pct": "91%",
      "action_plan": "Resume dispatch after clearance",
      "activation_date": "2026-07-21",
      "actual": 45.5,
      "comments": [],
      "dealer_code": "D100013",
      "dealer_name": "Partner Account 14",
      "district": "District W-A",
      "district_code": "DW01",
      "email_date": "2026-07-22",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 65,
      "id_issue": "ISS-2013",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 166.9,
      "plant_description": "Plant Beta",
      "region": "Area W1",
      "responsible_email_id": "owner5@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner F",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Transport not available for split drop",
      "state": "Zone West",
      "state_head": "Lead B",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater1@example.com",
      "updated_by_name": "Updater B",
      "view_state": ""
    },
    {
      "_id": "01d4ccdc0aa8d526e7e68775",
      "achievement_pct": "98%",
      "action_plan": "Share alternate supply plan",
      "activation_date": "2026-07-21",
      "actual": 49.0,
      "comments": [],
      "dealer_code": "D100014",
      "dealer_name": "Partner Account 15",
      "district": "District W-A",
      "district_code": "DW01",
      "email_date": "2026-07-23",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 70,
      "id_issue": "ISS-2014",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 178.2,
      "plant_description": "Plant Beta",
      "region": "Area W1",
      "responsible_email_id": "owner6@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner G",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Lead time higher than commitment",
      "state": "Zone West",
      "state_head": "Lead C",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater2@example.com",
      "updated_by_name": "Updater C",
      "view_state": ""
    },
    {
      "_id": "a44ac8cc9ec857c7e92aaba6",
      "achievement_pct": "5%",
      "action_plan": "Club with nearby partner orders",
      "activation_date": "",
      "actual": 52.5,
      "comments": [],
      "dealer_code": "D100015",
      "dealer_name": "Partner Account 16",
      "district": "District W-A",
      "district_code": "DW01",
      "email_date": "2026-07-09",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 75,
      "id_issue": "ISS-2015",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 189.5,
      "plant_description": "Plant Beta",
      "region": "Area W1",
      "responsible_email_id": "owner7@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner H",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Order stuck pending plant confirmation",
      "state": "Zone West",
      "state_head": "Lead D",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater3@example.com",
      "updated_by_name": "Updater D",
      "view_state": "Zone West"
    },
    {
      "_id": "d3b3128f6f2db45b33e88f66",
      "achievement_pct": "12%",
      "action_plan": "Follow up with plant operations",
      "activation_date": "2026-07-21",
      "actual": 56.0,
      "comments": [
        {
          "_id": "cmt161",
          "attachments": [],
          "author": {
            "email": "user1@example.com",
            "type": "OWNER"
          },
          "comment": "Status update 17",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2016",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100016",
      "dealer_name": "Partner Account 17",
      "district": "District W-B",
      "district_code": "DW02",
      "email_date": "2026-07-10",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 0,
      "id_issue": "ISS-2016",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "user1@example.com",
      "month": "Jul-26",
      "mtd_target": 200.8,
      "plant_description": "Plant Gamma",
      "region": "Area W2",
      "responsible_email_id": "owner0@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner A",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Supply delay impacting monthly target",
      "state": "Zone West",
      "state_head": "Lead E",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater4@example.com",
      "updated_by_name": "Updater E",
      "view_state": ""
    },
    {
      "_id": "65edb51645fd11aefe2c9373",
      "achievement_pct": "19%",
      "action_plan": "Confirm depot replenishment",
      "activation_date": "2026-07-21",
      "actual": 59.5,
      "comments": [],
      "dealer_code": "D100017",
      "dealer_name": "Partner Account 18",
      "district": "District W-B",
      "district_code": "DW02",
      "email_date": "2026-07-11",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 5,
      "id_issue": "ISS-2017",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 212.1,
      "plant_description": "Plant Gamma",
      "region": "Area W2",
      "responsible_email_id": "owner1@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner B",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Dispatch hold at origin",
      "state": "Zone West",
      "state_head": "Lead F",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater5@example.com",
      "updated_by_name": "Updater F",
      "view_state": ""
    },
    {
      "_id": "e6984ee17c2369281364cddc",
      "achievement_pct": "26%",
      "action_plan": "Coordinate with logistics for next slot",
      "activation_date": "",
      "actual": 63.0,
      "comments": [
        {
          "_id": "cmt181",
          "attachments": [],
          "author": {
            "email": "user3@example.com",
            "type": "OWNER"
          },
          "comment": "Status update 19",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2018",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100018",
      "dealer_name": "Partner Account 19",
      "district": "District W-B",
      "district_code": "DW02",
      "email_date": "2026-07-12",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 10,
      "id_issue": "ISS-2018",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "user3@example.com",
      "month": "Jul-26",
      "mtd_target": 23.4,
      "plant_description": "Plant Gamma",
      "region": "Area W2",
      "responsible_email_id": "owner2@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner C",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Material availability shortfall",
      "state": "Zone West",
      "state_head": "Lead A",
      "status": "CLOSED",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater0@example.com",
      "updated_by_name": "Updater A",
      "view_state": "Zone West"
    },
    {
      "_id": "b18f8215624ac3b575bd913d",
      "achievement_pct": "33%",
      "action_plan": "Resume dispatch after clearance",
      "activation_date": "2026-07-21",
      "actual": 66.5,
      "comments": [
        {
          "_id": "cmt191",
          "attachments": [],
          "author": {
            "email": "user4@example.com",
            "type": "RESPONSIBLE"
          },
          "comment": "Status update 20",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2019",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100019",
      "dealer_name": "Partner Account 20",
      "district": "District W-B",
      "district_code": "DW02",
      "email_date": "2026-07-13",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 15,
      "id_issue": "ISS-2019",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "user4@example.com",
      "month": "Jul-26",
      "mtd_target": 34.7,
      "plant_description": "Plant Gamma",
      "region": "Area W2",
      "responsible_email_id": "owner3@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner D",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Short delivery request pending",
      "state": "Zone West",
      "state_head": "Lead B",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater1@example.com",
      "updated_by_name": "Updater B",
      "view_state": ""
    },
    {
      "_id": "7666545621c8b9e2d28232cb",
      "achievement_pct": "40%",
      "action_plan": "Share alternate supply plan",
      "activation_date": "2026-07-21",
      "actual": 70.0,
      "comments": [],
      "dealer_code": "D100020",
      "dealer_name": "Partner Account 21",
      "district": "District S-A",
      "district_code": "DS01",
      "email_date": "2026-07-14",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 20,
      "id_issue": "ISS-2020",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 46.0,
      "plant_description": "Plant Delta",
      "region": "Area S1",
      "responsible_email_id": "owner4@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner E",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Depot stock outage",
      "state": "Zone South",
      "state_head": "Lead C",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater2@example.com",
      "updated_by_name": "Updater C",
      "view_state": ""
    },
    {
      "_id": "b3350ea4b233bfcf335a4473",
      "achievement_pct": "47%",
      "action_plan": "Club with nearby partner orders",
      "activation_date": "",
      "actual": 73.5,
      "comments": [],
      "dealer_code": "D100021",
      "dealer_name": "Partner Account 22",
      "district": "District S-A",
      "district_code": "DS01",
      "email_date": "2026-07-15",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 25,
      "id_issue": "ISS-2021",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 57.3,
      "plant_description": "Plant Delta",
      "region": "Area S1",
      "responsible_email_id": "owner5@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner F",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Transport not available for split drop",
      "state": "Zone South",
      "state_head": "Lead D",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater3@example.com",
      "updated_by_name": "Updater D",
      "view_state": "Zone South"
    },
    {
      "_id": "656a35af6f7a9c5b0c073f7f",
      "achievement_pct": "54%",
      "action_plan": "Follow up with plant operations",
      "activation_date": "2026-07-21",
      "actual": 77.0,
      "comments": [],
      "dealer_code": "D100022",
      "dealer_name": "Partner Account 23",
      "district": "District S-A",
      "district_code": "DS01",
      "email_date": "2026-07-16",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 30,
      "id_issue": "ISS-2022",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 68.6,
      "plant_description": "Plant Delta",
      "region": "Area S1",
      "responsible_email_id": "owner6@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner G",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Lead time higher than commitment",
      "state": "Zone South",
      "state_head": "Lead E",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater4@example.com",
      "updated_by_name": "Updater E",
      "view_state": ""
    },
    {
      "_id": "a292b97d4df40e89256608eb",
      "achievement_pct": "61%",
      "action_plan": "Confirm depot replenishment",
      "activation_date": "2026-07-21",
      "actual": 80.5,
      "comments": [
        {
          "_id": "cmt231",
          "attachments": [],
          "author": {
            "email": "user3@example.com",
            "type": "RESPONSIBLE"
          },
          "comment": "Status update 24",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2023",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100023",
      "dealer_name": "Partner Account 24",
      "district": "District S-A",
      "district_code": "DS01",
      "email_date": "2026-07-17",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 35,
      "id_issue": "ISS-2023",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "user3@example.com",
      "month": "Jul-26",
      "mtd_target": 79.9,
      "plant_description": "Plant Delta",
      "region": "Area S1",
      "responsible_email_id": "owner7@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner H",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Order stuck pending plant confirmation",
      "state": "Zone South",
      "state_head": "Lead F",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater5@example.com",
      "updated_by_name": "Updater F",
      "view_state": ""
    },
    {
      "_id": "31f208ae4d94e3f4987dc79f",
      "achievement_pct": "68%",
      "action_plan": "Coordinate with logistics for next slot",
      "activation_date": "",
      "actual": 84.0,
      "comments": [],
      "dealer_code": "D100024",
      "dealer_name": "Partner Account 25",
      "district": "District N-A",
      "district_code": "DN01",
      "email_date": "2026-07-18",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 40,
      "id_issue": "ISS-2024",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 91.2,
      "plant_description": "",
      "region": "Area N1",
      "responsible_email_id": "",
      "responsible_email_id_reporting_to": "",
      "responsible_name": "",
      "responsible_reporting_to_name": "",
      "root_cause": "Supply delay impacting monthly target",
      "state": "Zone North",
      "state_head": "Lead A",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater0@example.com",
      "updated_by_name": "Updater A",
      "view_state": "Zone North"
    },
    {
      "_id": "6b819d7283ae71a771969f79",
      "achievement_pct": "75%",
      "action_plan": "Resume dispatch after clearance",
      "activation_date": "2026-07-21",
      "actual": 87.5,
      "comments": [
        {
          "_id": "cmt251",
          "attachments": [],
          "author": {
            "email": "user0@example.com",
            "type": "RESPONSIBLE"
          },
          "comment": "Status update 26",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2025",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100025",
      "dealer_name": "Partner Account 26",
      "district": "District N-B",
      "district_code": "DN02",
      "email_date": "2026-07-19",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 45,
      "id_issue": "ISS-2025",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "user0@example.com",
      "month": "Jul-26",
      "mtd_target": 102.5,
      "plant_description": "Plant Alpha",
      "region": "Area N2",
      "responsible_email_id": "owner1@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner B",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Dispatch hold at origin",
      "state": "Zone North",
      "state_head": "Lead B",
      "status": "CLOSED",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater1@example.com",
      "updated_by_name": "Updater B",
      "view_state": ""
    },
    {
      "_id": "b3aa25c533f1448a53f075cc",
      "achievement_pct": "82%",
      "action_plan": "Share alternate supply plan",
      "activation_date": "2026-07-21",
      "actual": 91.0,
      "comments": [
        {
          "_id": "cmt261",
          "attachments": [],
          "author": {
            "email": "user1@example.com",
            "type": "OWNER"
          },
          "comment": "Status update 27",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2026",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100026",
      "dealer_name": "Partner Account 27",
      "district": "District E-A",
      "district_code": "DE01",
      "email_date": "2026-07-20",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 50,
      "id_issue": "ISS-2026",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "user1@example.com",
      "month": "Jul-26",
      "mtd_target": 113.8,
      "plant_description": "Plant Beta",
      "region": "Area E1",
      "responsible_email_id": "owner2@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner C",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Material availability shortfall",
      "state": "Zone East",
      "state_head": "Lead C",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater2@example.com",
      "updated_by_name": "Updater C",
      "view_state": ""
    },
    {
      "_id": "4124d981023f9c4722b59e46",
      "achievement_pct": "89%",
      "action_plan": "Club with nearby partner orders",
      "activation_date": "",
      "actual": 94.5,
      "comments": [],
      "dealer_code": "D100027",
      "dealer_name": "Partner Account 28",
      "district": "District E-B",
      "district_code": "DE02",
      "email_date": "2026-07-21",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 55,
      "id_issue": "ISS-2027",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 125.1,
      "plant_description": "Plant Gamma",
      "region": "Area E2",
      "responsible_email_id": "owner3@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner D",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Short delivery request pending",
      "state": "Zone East",
      "state_head": "Lead D",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater3@example.com",
      "updated_by_name": "Updater D",
      "view_state": "Zone East"
    },
    {
      "_id": "4d0d08ab0f7adf8689a8df76",
      "achievement_pct": "96%",
      "action_plan": "Follow up with plant operations",
      "activation_date": "2026-07-21",
      "actual": 98.0,
      "comments": [],
      "dealer_code": "D100028",
      "dealer_name": "Partner Account 29",
      "district": "District W-A",
      "district_code": "DW01",
      "email_date": "2026-07-22",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 60,
      "id_issue": "ISS-2028",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 136.4,
      "plant_description": "Plant Delta",
      "region": "Area W1",
      "responsible_email_id": "owner4@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner E",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Depot stock outage",
      "state": "Zone West",
      "state_head": "Lead E",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater4@example.com",
      "updated_by_name": "Updater E",
      "view_state": ""
    },
    {
      "_id": "860e0f7942eb97ad12c29306",
      "achievement_pct": "3%",
      "action_plan": "Confirm depot replenishment",
      "activation_date": "2026-07-21",
      "actual": 101.5,
      "comments": [],
      "dealer_code": "D100029",
      "dealer_name": "Partner Account 30",
      "district": "District W-B",
      "district_code": "DW02",
      "email_date": "2026-07-23",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 65,
      "id_issue": "ISS-2029",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 147.7,
      "plant_description": "",
      "region": "Area W2",
      "responsible_email_id": "",
      "responsible_email_id_reporting_to": "",
      "responsible_name": "",
      "responsible_reporting_to_name": "",
      "root_cause": "Transport not available for split drop",
      "state": "Zone West",
      "state_head": "Lead F",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater5@example.com",
      "updated_by_name": "Updater F",
      "view_state": ""
    },
    {
      "_id": "203cfd1605a861e3e82a0aba",
      "achievement_pct": "10%",
      "action_plan": "Coordinate with logistics for next slot",
      "activation_date": "",
      "actual": 105.0,
      "comments": [
        {
          "_id": "cmt301",
          "attachments": [],
          "author": {
            "email": "user0@example.com",
            "type": "OWNER"
          },
          "comment": "Status update 31",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2030",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100030",
      "dealer_name": "Partner Account 31",
      "district": "District S-A",
      "district_code": "DS01",
      "email_date": "2026-07-09",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 70,
      "id_issue": "ISS-2030",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "user0@example.com",
      "month": "Jul-26",
      "mtd_target": 159.0,
      "plant_description": "Plant Alpha",
      "region": "Area S1",
      "responsible_email_id": "owner6@example.com",
      "responsible_email_id_reporting_to": "manager2@example.com",
      "responsible_name": "Owner G",
      "responsible_reporting_to_name": "Manager C",
      "root_cause": "Lead time higher than commitment",
      "state": "Zone South",
      "state_head": "Lead A",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater0@example.com",
      "updated_by_name": "Updater A",
      "view_state": "Zone South"
    },
    {
      "_id": "dbce6302a5cb363e395b7c37",
      "achievement_pct": "17%",
      "action_plan": "Resume dispatch after clearance",
      "activation_date": "2026-07-21",
      "actual": 108.5,
      "comments": [],
      "dealer_code": "D100031",
      "dealer_name": "Partner Account 32",
      "district": "District C-A",
      "district_code": "DC01",
      "email_date": "2026-07-10",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 75,
      "id_issue": "ISS-2031",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 170.3,
      "plant_description": "Plant Beta",
      "region": "Area C1",
      "responsible_email_id": "owner7@example.com",
      "responsible_email_id_reporting_to": "manager3@example.com",
      "responsible_name": "Owner H",
      "responsible_reporting_to_name": "Manager D",
      "root_cause": "Order stuck pending plant confirmation",
      "state": "Zone Central",
      "state_head": "Lead B",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater1@example.com",
      "updated_by_name": "Updater B",
      "view_state": ""
    },
    {
      "_id": "2a2111862335d525dc2a953f",
      "achievement_pct": "24%",
      "action_plan": "Share alternate supply plan",
      "activation_date": "2026-07-21",
      "actual": 112.0,
      "comments": [
        {
          "_id": "cmt321",
          "attachments": [],
          "author": {
            "email": "user2@example.com",
            "type": "OWNER"
          },
          "comment": "Status update 33",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2032",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100032",
      "dealer_name": "Partner Account 33",
      "district": "District N-A",
      "district_code": "DN01",
      "email_date": "2026-07-11",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 0,
      "id_issue": "ISS-2032",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "user2@example.com",
      "month": "Jul-26",
      "mtd_target": 181.6,
      "plant_description": "Plant Gamma",
      "region": "Area N1",
      "responsible_email_id": "owner0@example.com",
      "responsible_email_id_reporting_to": "manager0@example.com",
      "responsible_name": "Owner A",
      "responsible_reporting_to_name": "Manager A",
      "root_cause": "Supply delay impacting monthly target",
      "state": "Zone North",
      "state_head": "Lead C",
      "status": "CLOSED",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater2@example.com",
      "updated_by_name": "Updater C",
      "view_state": ""
    },
    {
      "_id": "abfa3c0e7772d9952be19933",
      "achievement_pct": "31%",
      "action_plan": "Club with nearby partner orders",
      "activation_date": "",
      "actual": 115.5,
      "comments": [
        {
          "_id": "cmt331",
          "attachments": [],
          "author": {
            "email": "user3@example.com",
            "type": "RESPONSIBLE"
          },
          "comment": "Status update 34",
          "created_at": "2026-07-22T10:00:00.000Z",
          "id_issue": "ISS-2033",
          "is_deleted": false,
          "parent_comment_id": null,
          "updated_at": "2026-07-22T10:00:00.000Z"
        }
      ],
      "dealer_code": "D100033",
      "dealer_name": "Partner Account 34",
      "district": "District N-B",
      "district_code": "DN02",
      "email_date": "2026-07-12",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 5,
      "id_issue": "ISS-2033",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "PRIMARY",
        "value": "1000"
      },
      "last_comment_by": "user3@example.com",
      "month": "Jul-26",
      "mtd_target": 192.9,
      "plant_description": "Plant Delta",
      "region": "Area N2",
      "responsible_email_id": "owner1@example.com",
      "responsible_email_id_reporting_to": "manager1@example.com",
      "responsible_name": "Owner B",
      "responsible_reporting_to_name": "Manager B",
      "root_cause": "Dispatch hold at origin",
      "state": "Zone North",
      "state_head": "Lead D",
      "status": "COLLABORATION",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater3@example.com",
      "updated_by_name": "Updater D",
      "view_state": "Zone North"
    },
    {
      "_id": "7df04762e66c46c362ae2cfe",
      "achievement_pct": "38%",
      "action_plan": "Follow up with plant operations",
      "activation_date": "2026-07-21",
      "actual": 119.0,
      "comments": [],
      "dealer_code": "D100034",
      "dealer_name": "Partner Account 35",
      "district": "District E-A",
      "district_code": "DE01",
      "email_date": "2026-07-13",
      "email_type": "account_owner",
      "escalation": "E1",
      "forecast_shortfall": 10,
      "id_issue": "ISS-2034",
      "issue_category": {
        "category_code": "CATEGORY",
        "child_code": "SECONDARY",
        "value": "1000"
      },
      "last_comment_by": "",
      "month": "Jul-26",
      "mtd_target": 204.2,
      "plant_description": "",
      "region": "Area E1",
      "responsible_email_id": "",
      "responsible_email_id_reporting_to": "",
      "responsible_name": "",
      "responsible_reporting_to_name": "",
      "root_cause": "Material availability shortfall",
      "state": "Zone East",
      "state_head": "Lead E",
      "status": "OPEN",
      "updated_at": "2026-07-22T12:00:00.000Z",
      "updated_by": "updater4@example.com",
      "updated_by_name": "Updater E",
      "view_state": ""
    }
  ],
  "total": 0,
  "chart_data": null,
  "default_selection": {
    "dimensions": null,
    "measurements": null
  }
};

export default MOCK_RCA_RESPONSE;
